import { render, staticRenderFns } from "./loadings.vue?vue&type=template&id=502fa7fc&"
import script from "./loadings.vue?vue&type=script&lang=js&"
export * from "./loadings.vue?vue&type=script&lang=js&"
import style0 from "./loadings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports